import React, { useEffect } from "react";

const DataTranslationForm = ({ selectedNode }) => {
  const [showDropdown, setShowDropdown] = React.useState(false);
  const [translationType, setTranslationType] = React.useState((selectedNode.dataTranslation && selectedNode.dataTranslation.translationType) || 'None');
  const [templateString, setTemplateString] = React.useState((selectedNode.dataTranslation && selectedNode.dataTranslation.templateString) || '');

  const handleInputChange = (e) => {
    setTemplateString(e.target.value);
  };

  const onDropDown = () => {
    setShowDropdown(!showDropdown);
  };

  useEffect(() => {
    setShowDropdown(false);
    selectedNode.dataTranslation = {
      translationType: translationType,
      templateString: templateString
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [translationType, templateString]);



  useEffect(() => {
    // console.log("selectedNode changed", selectedNode);
    if (selectedNode.dataTranslation) {
      setTranslationType(selectedNode.dataTranslation.translationType);
      setTemplateString(selectedNode.dataTranslation.templateString);
    } else {
      setTranslationType('None');
      setTemplateString('');
    }
  }, [selectedNode]);

  return (
    <div className="text-gray-800">
      <div className="border-b border-gray-200 pb-4 text-center font-bold text-gray-900">
        Data Translate
      </div>

      <div className="mt-4 md:col-span-5">
        <label htmlFor="descr">Source Field</label>
        <input
          type="text"
          name="descr"
          id="descr"
          readOnly
          className="mt-1 h-10 w-full text-gray-900 rounded border bg-gray-50 px-4"
          value={selectedNode && selectedNode.source ? selectedNode.source.id : ""}
        />
      </div>

      <div className="mt-4 md:col-span-5">
        <label htmlFor="descr">Source Type</label>
        <input
          type="text"
          name="descr"
          id="descr"
          readOnly
          value={selectedNode && selectedNode.source && selectedNode.source.data ? selectedNode.source.data.type : ""}
          className="mt-1 h-10 w-full text-gray-900 rounded border bg-gray-50 px-4"
        />
      </div>

      <div className="mt-4 md:col-span-5">
        <div>
          <label htmlFor="int_name">Translation type</label>
        </div>
        <div className="relative mt-2 inline-block w-full text-left">
          <button
            onClick={onDropDown}
            className="bg-white dark:border-slate-700 inline-flex w-full items-center justify-between rounded border border-gray-200 px-4 py-2 text-gray-700 dark:bg-[#20293A] dark:text-gray-400"
          >
            <span>{translationType}</span>
            <svg
              className="ml-2 h-4 w-4"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M19 9l-7 7-7-7"
              ></path>
            </svg>
          </button>
          {showDropdown && (
            <div className="opacity-1 bg-white dark:border-slate-700 absolute z-40 mt-0 w-full rounded-md border border-gray-200 bg-white shadow-lg dark:bg-[#20293A]">
              <div
                className="py-1 text-sm text-gray-700 dark:text-gray-400"
                role="menu"
                aria-orientation="vertical"
                aria-labelledby="options-menu"
              >
                <button
                  onClick={() => setTranslationType('None')}
                  className="block w-full text-left px-4 py-2 hover:bg-gray-100 dark:hover:bg-[#161d2a]"
                  role="menuitem"
                >
                  None
                </button>
                <button
                  onClick={() => setTranslationType('ToUpperCase')}
                  className="block w-full text-left px-4 py-2 hover:bg-gray-100 dark:hover:bg-[#161d2a]"
                  role="menuitem"
                >
                  Upper Case
                </button>
                <button
                  onClick={() => setTranslationType('ToLowerCase')}
                  className="block w-full text-left px-4 py-2 hover:bg-gray-100 dark:hover:bg-[#161d2a]"
                  role="menuitem"
                >
                  Lower Case
                </button>
                <button
                  onClick={() => setTranslationType('TemplateString')}
                  className="block w-full text-left px-4 py-2 hover:bg-gray-100 dark:hover:bg-[#161d2a]"
                  role="menuitem"
                >
                  Template String
                </button>
              </div>
            </div>
          )}
        </div>
      </div>

      {translationType === 'TemplateString' && (
        <div className="mt-4 md:col-span-5">
          <div>
            <label htmlFor="template_string">Template String</label>
          </div>
          <div className="relative mt-2 inline-block w-full text-left">
            <input onChange={handleInputChange} value={templateString} type="text" name="template_string" id="template_string" className="mt-1 h-10 w-full text-gray-900 rounded border bg-gray-50 px-4" />
          </div>
        </div>
      )}

      <div className="mt-4 md:col-span-5">
        <label htmlFor="descr">Destination Field</label>
        <input
          type="text"
          name="descr"
          id="descr"
          readOnly
          className="mt-1 h-10 w-full text-gray-900 rounded border bg-gray-50 px-4"
          value={selectedNode && selectedNode && selectedNode.target ? selectedNode.target.id : ""}

        />
      </div>

      <div className="mt-4 md:col-span-5">
        <label htmlFor="descr">Destination Type</label>
        <input
          type="text"
          name="descr"
          id="descr"
          readOnly
          value={selectedNode && selectedNode.target && selectedNode.target.data ? selectedNode.target.data.type : ""}
          className="mt-1 h-10 w-full text-gray-900 rounded border bg-gray-50 px-4"
        />
      </div>

      {/* {selectedNode && (
        <div>
          <div className="pb-4 text-center font-bold">Translate Data</div>
          <p>
            <b>ID:</b> {selectedNode.id}
          </p>
          <p>
            <b>Label:</b> {selectedNode.data.label}
          </p>
        </div>
      )} */}
    </div>
  );
};

export default DataTranslationForm;
